import { render } from "./general_popup.vue?vue&type=template&id=b32bc436&scoped=true"
import script from "./general_popup.vue?vue&type=script&lang=js"
export * from "./general_popup.vue?vue&type=script&lang=js"

import "./general_popup.vue?vue&type=style&index=0&id=b32bc436&scoped=true&lang=css"

import exportComponent from "/Users/danramage/Documents/workspace/WaterQuality/WaterQualityFrontEnd_Vue3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b32bc436"]])

export default __exports__